// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CarryOutOutlinedSvg from "@ant-design/icons-svg/es/asn/CarryOutOutlined";
import AntdIcon from '../components/AntdIcon';

var CarryOutOutlined = function CarryOutOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CarryOutOutlinedSvg
  }));
};

CarryOutOutlined.displayName = 'CarryOutOutlined';
export default React.forwardRef(CarryOutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CarryOutOutlined.js
// module id = 743
// module chunks = 0